import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class PayrollItemAPI extends DIApi {
  controllerName = 'PayrollItems';

  /**
   * Hàm lấy dữ liệu khấu trừ
   * @param {} param
   * @returns
   */
  getRecurrentData(param) {
    let request = {
      url: this.getAPIUrl() + '/recurrent',
      data: param,
    };

    return httpClient.postAsync(request);
  }
}

export default new PayrollItemAPI();
